import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import size from 'lodash/size';

import { modalOpen } from '../../actions/modals';
import isURL from 'validator/lib/isURL';


const mapStateToProps = state => ({ modalOpened: size(state.modals) > 0 });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ modalOpen }, dispatch);
};


class LinkPaster extends Component {
  
  constructor (props) {
    super(props);
    this.onPaste = this.onPaste.bind(this);
  }
  
  componentWillMount() {
    // console.log("LinkPaster Mounted")
    document.addEventListener('paste', this.onPaste)
  }
  
  componentWillUnmount() {
    // console.log("LinkPaster Unmounted")
    document.removeEventListener('paste', this.onPaste)
  }
  
  onPaste(e) {
    const { modalOpen, modalOpened } = this.props;
    if (e.target.tagName.toLowerCase() === 'input' || modalOpened)
      return;
    
    const pasted = e.clipboardData.getData('Text');
    if ( isURL(pasted) )
      modalOpen('newLink', {url: pasted, size: "lg"})
  }
  
  render() {
    return null
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(LinkPaster);


// WEBPACK FOOTER //
// ./src/components/helpers/LinkPaster.js